import '@shui/core/sh-list';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-list-item',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.active]': 'active() ? "" : null',
        '[attr.clickable]': 'clickable() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.divider]': 'divider() ?? null',
        '[attr.hide-link-arrow]': 'hideLinkArrow() ? "" : null',
        '[attr.href]': 'href() ?? null',
        '[attr.icon]': 'icon() ?? null',
        '[attr.icon-color]': 'iconColor() ?? null',
        '[attr.icon-size]': 'iconSize() ?? null',
        '[attr.info]': 'info() ?? null',
        '[attr.label]': 'label() ?? null',
        '[attr.override]': 'override() ?? null',
        '[attr.selectable]': 'selectable() ? "" : null',
        '[attr.toggle]': 'toggle() ? "" : null',
        '[attr.vertical-align]': 'verticalAlign() ?? null'
    }
})
export class ShListItemComponent {
    /**
     * Defines the active state of the list Item.  If set to `true`, the style will adapt to
     * represent that the item is currently active.
     */
    public readonly active = input(false, { transform: booleanAttribute });

    /**
     * Defines the interactive state of the list Item. When set, list item hover styles are applied
     * and it is clickable
     */
    public readonly clickable = input(false, { transform: booleanAttribute });

    /** If set to true, the item will be shown as disabled and won't allow clicks. */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /**
     * Defines the divider style placed between the list item. Possible values are `inset-
     * left`,`inset`,`full-width`,`none`.
     */
    public readonly divider = input<string | number | undefined>(undefined);

    /** Hides the arrow shown when `href` is set along with this property . */
    public readonly hideLinkArrow = input(false, { transform: booleanAttribute });

    /**
     * Defines the href of the list Item. When specified, the list item can be used to navigate to
     * the provided link on click.
     */
    public readonly href = input<string | number | undefined>(undefined);

    /** Defines the icon of the list Item. */
    public readonly icon = input<string | number | undefined>(undefined);

    /** Defines the icon color of the list item icon. */
    public readonly iconColor = input<string | number | undefined>(undefined);

    /** Defines the  icon size of the list item icon. Possible values are `s`, `m`, `l`. */
    public readonly iconSize = input<string | number | undefined>(undefined);

    /** Defines the info of the list Item. */
    public readonly info = input<string | number | undefined>(undefined);

    /** Defines the label of the list Item. */
    public readonly label = input<string | number | undefined>(undefined);

    public readonly override = input<string | number | undefined>(undefined);

    /**
     * Defines the selectable property of the list Item. Adds checkbox/ radio-button based on the
     * `selection-type` of the list
     */
    public readonly selectable = input(false, { transform: booleanAttribute });

    /** Defines the toggling of the active state of the list Item. */
    public readonly toggle = input(false, { transform: booleanAttribute });

    /**
     * Defines the vertical alignment of the list Item's checkbox when `selectable` is set or arrow
     * when `href` is set. Possible values are `center` and `top`.
     */
    public readonly verticalAlign = input<string | number | undefined>(undefined);
}
